var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-tooltip/src/TooltipPure.js";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultAttributes } from '@nike/nr-sole-xl-theme-provider';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import { compose, css } from 'glamor';
var colors = defaultAttributes.colors;

var TooltipPure =
/*#__PURE__*/
function (_Component) {
  _inherits(TooltipPure, _Component);

  function TooltipPure() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TooltipPure);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TooltipPure)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isDisabled: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOnOpen", function (evt) {
      var _this$props = _this.props,
          onOpen = _this$props.onOpen,
          onRequestOpen = _this$props.onRequestOpen;

      _this.setState({
        isDisabled: onRequestOpen ? onRequestOpen(evt) : false
      }, function () {
        if (onOpen) onOpen(evt);
      });
    });

    return _this;
  }

  _createClass(TooltipPure, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          dataE2E = _this$props2['data-e2e'],
          disableArrow = _this$props2.disableArrow,
          disabled = _this$props2.disabled,
          id = _this$props2.id,
          onRequestOpen = _this$props2.onRequestOpen,
          placement = _this$props2.placement,
          styles = _this$props2.styles,
          title = _this$props2.title,
          type = _this$props2.type,
          wrapText = _this$props2.wrapText,
          rest = _objectWithoutProperties(_this$props2, ["children", "data-e2e", "disableArrow", "disabled", "id", "onRequestOpen", "placement", "styles", "title", "type", "wrapText"]);

      var isDisabled = this.state.isDisabled;
      var arrowPlacementBottom = styles.arrowPlacementBottom,
          arrowPlacementLeft = styles.arrowPlacementLeft,
          arrowPlacementRight = styles.arrowPlacementRight,
          arrowPlacementTop = styles.arrowPlacementTop,
          popper = styles.popper,
          tooltip = styles.tooltip,
          tooltipArrow = styles.tooltipArrow,
          tooltipPlacementBottom = styles.tooltipPlacementBottom,
          tooltipPlacementLeft = styles.tooltipPlacementLeft,
          tooltipPlacementRight = styles.tooltipPlacementRight,
          tooltipPlacementTop = styles.tooltipPlacementTop,
          tooltipTypeAction = styles.tooltipTypeAction,
          tooltipTypeError = styles.tooltipTypeError,
          tooltipTypeSuccess = styles.tooltipTypeSuccess,
          tooltipTypeWarning = styles.tooltipTypeWarning,
          touch = styles.touch;
      var appliedPlacementBottomStyle = compose([tooltipPlacementBottom, !disableArrow && arrowPlacementBottom, !disableArrow && tooltipArrow]);
      var appliedPlacementLeftStyle = compose([tooltipPlacementLeft, !disableArrow && arrowPlacementLeft, !disableArrow && tooltipArrow]);
      var appliedPlacementRightStyle = compose([tooltipPlacementRight, !disableArrow && arrowPlacementRight, !disableArrow && tooltipArrow]);
      var appliedPlacementTopStyle = compose([tooltipPlacementTop, !disableArrow && arrowPlacementTop, !disableArrow && tooltipArrow]);
      var appliedTooltipStyle = compose([tooltip, !wrapText && {
        maxWidth: 'none'
      }, type === 'action' && tooltipTypeAction, type === 'error' && tooltipTypeError, type === 'success' && tooltipTypeSuccess, type === 'warning' && tooltipTypeWarning]);
      if (disabled || isDisabled || !title) return children;
      return React.createElement(Tooltip, _extends({
        classes: {
          popper: css(popper).toString(),
          tooltip: appliedTooltipStyle.toString(),
          tooltipPlacementBottom: appliedPlacementBottomStyle.toString(),
          tooltipPlacementLeft: appliedPlacementLeftStyle.toString(),
          tooltipPlacementRight: appliedPlacementRightStyle.toString(),
          tooltipPlacementTop: appliedPlacementTopStyle.toString(),
          touch: css(touch).toString()
        },
        "data-e2e": dataE2E,
        id: id,
        onOpen: this.handleOnOpen,
        placement: placement,
        title: title
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        },
        __self: this
      }), children);
    }
  }]);

  return TooltipPure;
}(Component);

TooltipPure.propTypes = {
  /** Tooltip reference element. */
  children: PropTypes.element.isRequired,

  /** Passed down to all DOM elements to allow E2E testing. */
  'data-e2e': PropTypes.string,

  /** If true, no arrows are rendered on the tooltip. */
  disableArrow: PropTypes.bool,

  /** If true, Tooltip is deactivated. */
  disabled: PropTypes.bool,

  /** Do not respond to focus events. */
  disableFocusListener: PropTypes.bool,

  /** Do not respond to hover events. */
  disableHoverListener: PropTypes.bool,

  /** Do not respond to long press touch events. */
  disableTouchListener: PropTypes.bool,

  /** The number of milliseconds to wait before showing the tooltip. This property won't impact
   * the enter touch delay (enterTouchDelay). */
  enterDelay: PropTypes.number,

  /** The number of milliseconds a user must touch the element before showing the tooltip. */
  enterTouchDelay: PropTypes.number,

  /** Component ID. */
  id: PropTypes.string,

  /** The number of milliseconds to wait before hiding the tooltip. This property won't impact
   * the leave touch delay (leaveTouchDelay). */
  leaveDelay: PropTypes.number,

  /** The number of milliseconds after the user stops touching an element before hiding the
   * tooltip. */
  leaveTouchDelay: PropTypes.number,

  /** Callback fired when the tooltip requests to be closed. `function(event: object) => void` */
  onClose: PropTypes.func,

  /** Callback fired when the tooltip requests to be open. `function(event: object) => void` */
  onOpen: PropTypes.func,

  /** Callback that can be used to intercept open event and set internal state.
   *  `function(event: object) => void` */
  onRequestOpen: PropTypes.func,

  /** If true, the tooltip is shown. */
  open: PropTypes.bool,

  /** Tooltip placement. */
  placement: PropTypes.oneOf(['bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start']),

  /** Properties applied to the Popper element. */
  PopperProps: PropTypes.shape({}),

  /** Applied styles. */
  styles: PropTypes.shape({
    arrowPlacementBottom: PropTypes.object,
    arrowPlacementLeft: PropTypes.object,
    arrowPlacementRight: PropTypes.object,
    arrowPlacementTop: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    tooltipArrow: PropTypes.object,
    tooltipPlacementBottom: PropTypes.object,
    tooltipPlacementLeft: PropTypes.object,
    tooltipPlacementRight: PropTypes.object,
    tooltipPlacementTop: PropTypes.object,
    tooltipTypeAction: PropTypes.object,
    tooltipTypeError: PropTypes.object,
    tooltipTypeSuccess: PropTypes.object,
    tooltipTypeWarning: PropTypes.object,
    touch: PropTypes.object
  }),

  /** Tooltip title. Zero-length titles string are never displayed. */
  title: PropTypes.node,

  /** Transition component. */
  TransitionComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),

  /** Properties applied to the Transition element. */
  TransitionProps: PropTypes.shape({}),

  /** A shorthand for contextual theming of the Tooltip. */
  type: PropTypes.oneOf(['action', 'default', 'error', 'success', 'warning']),

  /** If true, text is not wrapped by default. */
  wrapText: PropTypes.bool
};
TooltipPure.defaultProps = {
  disableArrow: false,
  disabled: false,
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom',
  styles: {
    arrowPlacementBottom: {
      '&::before': {
        borderBottom: '6px solid currentColor',
        borderLeft: "6px solid ".concat(colors.transparent, " !important"),
        borderRight: "6px solid ".concat(colors.transparent, " !important"),
        bottom: '100%',
        content: '""',
        left: '50%',
        margin: 'auto',
        position: 'absolute',
        transform: 'translateX(-50%)'
      }
    },
    arrowPlacementLeft: {
      '&::before': {
        borderBottom: "6px solid ".concat(colors.transparent, " !important"),
        borderLeft: '6px solid currentColor',
        borderTop: "6px solid ".concat(colors.transparent, " !important"),
        bottom: '50%',
        content: '""',
        left: '100%',
        margin: 'auto',
        position: 'absolute',
        transform: 'translateY(50%)'
      }
    },
    arrowPlacementRight: {
      '&::before': {
        borderBottom: "6px solid ".concat(colors.transparent, " !important"),
        borderRight: '6px solid currentColor',
        borderTop: "6px solid ".concat(colors.transparent, " !important"),
        bottom: '50%',
        content: '""',
        margin: 'auto',
        position: 'absolute',
        right: '100%',
        transform: 'translateY(50%)'
      }
    },
    arrowPlacementTop: {
      '&::before': {
        borderLeft: "6px solid ".concat(colors.transparent, " !important"),
        borderRight: "6px solid ".concat(colors.transparent, " !important"),
        borderTop: '6px solid currentColor',
        content: '""',
        left: '50%',
        margin: 'auto',
        position: 'absolute',
        top: '100%',
        transform: 'translateX(-50%)'
      }
    },
    popper: {
      zIndex: 2000
    },
    tooltip: {},
    tooltipArrow: {
      '::before': {
        color: '#616161'
      }
    },
    tooltipPlacementBottom: {},
    tooltipPlacementLeft: {},
    tooltipPlacementRight: {},
    tooltipPlacementTop: {},
    tooltipTypeAction: {},
    tooltipTypeError: {},
    tooltipTypeSuccess: {},
    tooltipTypeWarning: {},
    touch: {}
  },
  TransitionComponent: Zoom,
  type: 'default',
  wrapText: true
};
TooltipPure.displayName = 'TooltipPure';
export default TooltipPure;